/**
 * La doc v1.8.4 annonce `data.items[]` sur les listes, mais le back dev renvoie
 * un tableau nu sur `GET /v1/users` et `GET /v1/invitation`. On accepte les deux.
 */
export type ListPayload<T> = T[] | { items: T[] };

export const unwrapItems = <T>(payload: ListPayload<T> | null | undefined): T[] => {
  if (!payload) return [];
  return Array.isArray(payload) ? payload : (payload.items ?? []);
};
